import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { forwardRef } from 'react';
import MaterialIconButton from '@mui/material/IconButton';

var _excluded = ["className"];
var BaseIconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React__default.createElement(MaterialIconButton, _extends({
    ref: ref,
    className: className
  }, rest));
});

export { BaseIconButton as default };
//# sourceMappingURL=BaseIconButton.js.map
